import React, { useCallback, useMemo } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

import { NotificationManager } from '@atlas/core';
import { BasePopup, Button } from '@atlas/ui';

import StaticBlock from 'common/StaticBlock/StaticBlock';
import { useIsRtl } from 'hooks/useIsRtl';

const MultiPopup = ({
  data: { link = '', onClose = () => {}, open = '_top', staticBlock } = {},
  id,
}) => {
  const isRtl = useIsRtl();
  const classNames = useMemo(
    () => ({
      content: cx('messages-popup__content messages-popup__content-multi', {
        'messages-popup__content-multi-rtl': isRtl,
      }),
      headerChildren: cx('header-title__children', {
        'header-title__children-multi-rtl': isRtl,
      }),
    }),
    [isRtl],
  );
  const onCloseHandler = useCallback(() => {
    NotificationManager.removeNotification(id);
    onClose();
  }, [id, onClose]);

  return (
    <BasePopup className="messages-popup">
      <div className={classNames.content}>
        <StaticBlock
          options={{
            source: staticBlock,
          }}
        />
      </div>

      <div className="messages-popup__control">
        <Button
          className="secondary big block"
          label="multi_popup_button_name_close"
          onClick={onCloseHandler}
        />
        <Button
          className="primary big block"
          label="multi_popup_button_name"
          onClick={onCloseHandler}
        >
          {!!link && <a className="messages-popup__control-link" href={link} target={open} />}
        </Button>
      </div>
    </BasePopup>
  );
};

MultiPopup.propTypes = {
  data: PropTypes.shape({
    link: PropTypes.string,
    onClose: PropTypes.func,
    open: PropTypes.string,
    staticBlock: PropTypes.node,
  }).isRequired,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default MultiPopup;
